import "./App.css"
import "react-toastify/dist/ReactToastify.css"
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom"
import { useState, useEffect } from "react"

import NavBar from "./components/Nav/NavBar"
import Footer from "./components/Footer"

import Home from "./Account_Panels/Public/Home"
import ProductPage from "./Account_Panels/Public/Product/ProductPage"
import Product from "./components/Product"
import Cart from "./components/Cart"
import Checkout from "./components/Checkout/Checkout"

import Login from "./Auth/Login"
import SignUp from "./Auth/SignUp"
import AccountPage from "./Auth/AccountPage"
import VerifyEmail from "./Auth/VerifyEmail"
import ForgotPassword from "./Auth/ForgotPassword"
import ResetPassword from "./Auth/ResetPassword"
import CompanySignUpForm from "./components/CompanySignUpForm"

import RequireAuth from "./Auth/RequireAuth"
import VerifyNotice from "./Auth/VerifyNotice"
import UserProfile from "./Account_Panels/Admin/Users/UserProfile"

import CartContext from "./context/cartContext"
import { AuthProvider } from "./context/userContext"
import { SnackbarProvider } from "./context/snackbar"
import ListDetail from "./Account_Panels/User/List/ListDetail"

function App() {
  const [cart, setCart] = useState([])
  const [cartLoading, setCartLoading] = useState(true)

  /* =====================================================
     LOAD CART ON APP START (PERSISTENCE)
  ===================================================== */
  useEffect(() => {
    const fetchCart = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/me/cart`, {
          credentials: "include",
        })

        if (!res.ok) throw new Error("Failed to fetch cart")

        const data = await res.json()

        setCart(Array.isArray(data) ? data : [])
      } catch (err) {
        console.error("Cart sync error:", err)
        setCart([])
      } finally {
        setCartLoading(false)
      }
    }

    fetchCart()
  }, [])

  return (
    <AuthProvider>
      <CartContext.Provider
        value={{
          cart,
          setCart,
          cartLoading, // optional but useful for badge/cart UI
        }}
      >
        <SnackbarProvider>
          <Router>
            <div className="App d-flex flex-column min-vh-100">
              <NavBar />

              <Routes>
                {/* PUBLIC ROUTES */}
                <Route path="/" element={<Home />} />
                <Route path="/products" element={<ProductPage />} />
                <Route path="/products/:id" element={<Product />} />

                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<SignUp />} />
                <Route path="/signup/company" element={<CompanySignUpForm />} />

                <Route path="/verify-email" element={<VerifyNotice />} />
                <Route path="/verify/:ev_str" element={<VerifyEmail />} />

                {/* Onboarding is now part of sign-up */}
                <Route path="/onboarding" element={<Navigate to="/account" replace />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route
                  path="/reset-password/:ev_str"
                  element={<ResetPassword />}
                />
                <Route path="/lists/:id" element={<ListDetail />} />
                <Route path="/users/:id" element={<UserProfile />} />

                {/* PROTECTED ROUTES */}
                <Route
                  path="/cart"
                  element={
                    <RequireAuth>
                      <Cart />
                    </RequireAuth>
                  }
                />

                <Route
                  path="/checkout"
                  element={
                    <RequireAuth>
                      <Checkout />
                    </RequireAuth>
                  }
                />

                <Route
                  path="/account"
                  element={
                    <RequireAuth>
                      <AccountPage />
                    </RequireAuth>
                  }
                />

                {/* FALLBACK */}
                <Route path="/*" element={<Home />} />
              </Routes>

              <Footer />
            </div>
          </Router>
        </SnackbarProvider>
      </CartContext.Provider>
    </AuthProvider>
  )
}

export default App
